module.exports = __webpack_public_path__ + "static/img/pic23.6c729e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic23.png
// module id = ijLS
// module chunks = 0